namespace('compass.hotel');

compass.requireLib('compass.util.parse');
compass.requireLib('compass.util.format');

compass.hotel.HotelFilterWidget = compass.defineWidget(function HotelFilterWidget(options) {
	var me = this;
	var $j = jQuery;

	$viewport = $j('#viewport');

	// REMOVE THIS, JUST FOR STUBBING
	test = {};

	var _settings = options;
	var _validator = null;
	var _format = compass.util.dateFormatter('yyyy-mm-dd');
	var _displayDateFormat = _settings.dateFormat;
	if(_settings.dateFormat === 'ddd, mmmm dd, yyyy' || _settings.dateFormat === 'mmmm dd, yyyy'){
		_displayDateFormat = 'mm/dd/yyyy';
	}else if(_settings.dateFormat === 'ddd, dd mmmm, yyyy'){
		_displayDateFormat = 'dd/mm/yyyy';
	}
	var _displayDateFormatter = compass.util.dateFormatter(_displayDateFormat.toLowerCase());

	var _requireCheckInOutDates = _settings.requireCheckInOutDates;

	var _currFilter = { };
	var _availSlider;
	var _hotels = _settings.hotels;
	var _widgetElem;

	var _showName = _settings.meetingInfo.name;
    var _firedGINAlert = false;

	var default_sort_distance = _settings.default_sort_distance;
	var explicitSort = _settings.explicitSort;

	// track whether this is the very first date search (for google analytics tracking)
	var firstDateSearch = true;
	var _firstQuerySearch = true;

	this.validate = function() {
		this.validator.validateAll();
		return this.validator.valid;
	};

	this.setupControls = function() {
		var mapView = me.find('.mapview');
		var gridView = me.find('.gridview');

		mapView.activate(function() {
			me.trigger('HotelFilterWidget.mapViewClicked');
			mapView.removeClass('inactive');
			gridView.addClass('inactive');
		});

		gridView.activate(function() {
			me.trigger('HotelFilterWidget.gridViewClicked');
			mapView.addClass('inactive');
			gridView.removeClass('inactive');
		});
		getArriveInput().parsley({
			aria: true,
			errorClass: 'invalid'
		});
		getDepartInput().parsley({
			aria: true,
			errorClass: 'invalid'
		});

		$viewport.bind(CompassEvents.ViewLoaded, function(e){
			jQuery('.btn_nightlyAvailability').activate( function(){
				compass.GA.trackEvent('Filter', 'View Nightly Availability', 'Nightly Availability');
				me.trigger('HotelFilterWidget.showNightlyAvailabilityPopup');
			} );
		} );

	};

	var generateFilterKey = (function() {
		var n = 0;
		return function() {
			return 'filter_key_' + (++n);
		};
	})();

	function updateFilter(key, label, value, type) {
		var filterType = type || 'generic';

		// Log filter interactions to GA
		// Arrive/depart are logged separately and are ignored here
		var eventAction;
		var eventLabel;
		if (filterType === 'stars') {
			eventAction = 'Star Rating';
			eventLabel = label.toString() + ' stars';
		} else if (filterType === 'amenity') {
			eventAction = 'Amenities';
			eventLabel = label;
		} else if (filterType === 'generic') {
			if (label === 'price') {
				eventAction = 'Price';
				eventLabel = 'Adjust Price Slider';
			} else if (label === 'availability') {
				eventAction = 'Number of Rooms';
				eventLabel = 'Adjust Number of Rooms Slider';
			} else if (label === 'query' && value.length > 0 && _firstQuerySearch) {
				_firstQuerySearch = false;
				eventAction = 'Search';
				eventLabel = 'Initial Search';
			}
		}
		if (eventAction && eventLabel) {
			compass.GA.trackEvent('Filter', eventAction, eventLabel);
		}

		_currFilter[key] = { key : label, value : value, type : filterType };
	}

	function sendGATracking() {
		if (!firstDateSearch) { // user is filtering AFTER initial search
			compass.GA.trackEvent("Filter", "Change Check In/Out Dates", "Adjust Check In/Out dates after the initial search");
		} else if (!_settings.meetingInfo.entryDatesDefaultToBlank) { // initial search, dates are pre-filled
			compass.GA.trackEvent("Filter", "Change Check In/Out Dates", "Adjust Check In/Out dates when they are pre-filled");
		} else if (!_settings.meetingInfo.requiredCheckInOutDates) { // initial search, dates are blank, dates are not required to see hotels
			compass.GA.trackEvent("Filter", "Change Check In/Out Dates", "Adjust Check In/Out dates when they are blank");
		}
	}

	this.render = function(widgetElem) {
		var d = _d;
		_widgetElem = widgetElem;
		var _labelId = compass.generateId();
		widgetElem.append(
			d.reader( d.h2({id: _labelId}, 'Hotel Filter – adjust options to refine results') ),
			_settings.displayPriceSavings && this.drawPriceSavingsExplanation(),
			me.drawViewControls(),
			me.drawArriveDepart(),
			me.drawSearch(),
			_settings.hideDistance ? "" : me.drawDistanceSort(),
			d.div({ className: 'sliders' },
				me.drawAvailabilitySlider(),
				d.div({ className: 'sectionHeader' }, d.h3({ className : 'sectionTitle'}, 'Price')),
				me.drawPriceSlider()
			),
			me.drawSearchOptions()
		);

		widgetElem.attr('ARIA-labelledby', _labelId);
		me.setupControls();
	};

	var _trackFirstUse = _.once(function() {
		compass.trackEvent('FilterFirstUse');
	} );

	this.dispatchChange = (function() {
		var timeout = null;
		function trigger() {
			me.trigger('HotelFilterWidget.dataChanged', _currFilter);
			_trackFirstUse();
			timeout = null;
		}
		return function(addDelay) {
			if(timeout != null) {
				window.clearTimeout(timeout);
			}
			var delay = _settings.filterChangeDelay + (addDelay || 0);
			timeout = window.setTimeout(trigger, delay);
		};
	})();

	this.unsetFilter = function(key) {
		delete _currFilter[key];
		var input = me.find('input.' + key);
		var type = input.attr('type');
		if(type == 'text' || type == 'textarea') {
			input.val('');
		} else if(type == 'checkbox') {
			input.removeAttr('checked');
		}
	};

	this.drawViewControls = function() {
		var d = _d;
		var nightAvailHTML = [
			d.hr(),
			d.div({
					className : 'btn_nightlyAvailability filterView',
					role : 'button',
					'ARIA-role' : 'button',
					'ARIA-label' : 'Popup Grid Display',
					tabindex : 0
				}, 'Nightly Availability'
			)
		];
		var nightAvail = options.showInventoryMatrix ? nightAvailHTML : [];


		return d.div({ className : 'viewControls', 'ARIA-label' : 'Results Display Options' },
			d.centered(
				d.div({
					className : 'gridview filterView',
					role : 'button',
					'ARIA-role' : 'button',
					'ARIA-label' : 'Display as Gallery',
					tabindex : 0
				},
					d.div({ className : 'filterLabel' }, 'Gallery'),
					d.img({ className : 'gridIcon', src : compass.staticPrefix + '/resources/img/blank.gif' })
				),
				d.div({
					className : 'mapview filterView inactive',
					role : 'button',
					'ARIA-role' : 'button',
					'ARIA-label' : 'Display on Map',
					tabindex : 0
				},
					d.div({ className : 'filterLabel' }, 'Map'),
					d.img({ className : 'mapIcon', src : compass.staticPrefix + '/resources/img/blank.gif' })
				),
				nightAvail
			)
		);
	};

	function getDefaultDates(){
		var meetingStarts = compass.util.parse.ISODateParser(_settings.meetingInfo.starts);
		meetingStarts.setDate(meetingStarts.getDate()-1);
		//var arrive = meetingStarts.toISOString().slice(0,10);
		var arrive = meetingStarts;

		var depart = compass.util.parse.ISODateParser(_settings.meetingInfo.ends);
		//depart = depart.toISOString().slice(0,10);

		return {
			'arrive':arrive,
			'depart': depart
		};
	}

	function getArriveInput(){
		return me.getWidgetElem().find('.arriveDateInput');
	}

	function getDepartInput(){
		return me.getWidgetElem().find('.departDateInput');
	}

	this.setArriveDepartDates = function(arriveDate, departDate){
		var arriveDateInput = me.getWidgetElem().find('.arriveDateInput');
		var departDateInput = me.getWidgetElem().find('.departDateInput');
		// sets the value of the date picker and visually in the input
		arriveDateInput.datepicker('setDate',_displayDateFormatter(arriveDate)); 
		departDateInput.datepicker('setDate',_displayDateFormatter(departDate)); 
		//arriveDateInput.trigger("change", false); // false means don't auto focus date pickers
		//departDateInput.trigger("change", false); // false means don't auto focus date pickers
	};

	this.drawArriveDepart = function () {
		var d = _d;
		var minIn = compass.util.parse.ISODateParser(_settings.nightsArray[0]); // ?
		var maxIn = compass.util.parse.ISODateParser(_settings.nightsArray[(_settings.nightsArray.length-1)]); // ?
		var minOut = compass.util.parse.ISODateParser(_settings.nightsArray[0]); // ?
		var maxOut = compass.util.parse.ISODateParser(_settings.nightsArray[(_settings.nightsArray.length-1)]); // ?
		var defaultIn = compass.util.parse.ISODateParser(_settings.meetingInfo.starts);
		var defaultOut = compass.util.parse.ISODateParser(_settings.meetingInfo.ends);
		var keys = [generateFilterKey(), generateFilterKey()];
		var dateTimer = null;		
		var arriveOpen = false;
		var departOpen = false;
		var arriveId = compass.generateId();
		var departId = compass.generateId();

		me.alertBothDates = function(){
			d.alert('You must enter both a check-in AND check-out date for us to update hotels and rates.');
		};

		me.alertDatesOrder = function(){
			d.alert('Check-In date must come before Check-Out date');
		};

		me.resetFilterToDefault = function(){
			//set arrive and depart values for hotelInfo url params
			me.arrive = _format(defaultIn);
			me.depart = _format(defaultOut);

			// Reset the filter dates to the default dates
			updateFilter(keys[0], 'arrive', me.arrive);
			updateFilter(keys[1], 'depart', me.depart);

			me.dispatchChange(100);
		};

		defaultIn.setDate(defaultIn.getDate()-1); //default start date is one day before show starts
		
		if (!_settings.defaultFilterDatesToBlank){
			//set arrive and depart values for hotelInfo url params
			me.arrive = _format(defaultIn);
			me.depart = _format(defaultOut);

			updateFilter(keys[0], 'arrive', me.arrive);
			updateFilter(keys[1], 'depart', me.depart);
		}

		// the internal date picker values are always the default dates so that the picker defaults to the default dates when you click on them
		// later on in this funciton we set the visual text to '' if the meeting rule of defaultFilterDatesToBlank is set to Y so that it looks like they are empty
		// if the rule is on, when you first get to the page, the first avail call will still not have arrive/depart dates, by design

		var arriveInput = d.input({
			className: 'arriveDateInput',
			type: 'text',
			name: 'arrive',
			'data-regexp':'^[0-3]?[0-9]/[0-3]?[0-9]/(?:[0-9]{2})?[0-9]{2}$',
			value: _displayDateFormatter(defaultIn),
			title: _displayDateFormat,
			id: arriveId
		});
		var departInput = d.input({
			className: 'departDateInput',
			type: 'text',
			name: 'depart',
			'data-regexp':'^[0-3]?[0-9]/[0-3]?[0-9]/(?:[0-9]{2})?[0-9]{2}$', 
			value: _displayDateFormatter(defaultOut),
			title: _displayDateFormat,
			id: departId
		});

		$(arriveInput).datepicker({dateFormat:_displayDateFormat.toLowerCase().substring(0,8), showAnim:"", minDate:minIn, maxDate:maxIn, defaultDate:defaultIn});
		$(departInput).datepicker({dateFormat:_displayDateFormat.toLowerCase().substring(0,8), showAnim:"", minDate:minOut, maxDate:maxOut, defaultDate:defaultOut});
		$('.ui-datepicker').addClass('notranslate');

		arriveInput.click(function(evt){
			if(!arriveInput.datepicker("widget").is(":visible"))
				arriveInput.datepicker("show");
		});

		departInput.click(function(evt){
			if(!departInput.datepicker("widget").is(":visible"))
				departInput.datepicker("show");
		});

		arriveInput.keyup(function(evt){
			getArriveInput().parsley().validate();

			if(getArriveInput().val().length === 0 && getDepartInput().val().length === 0){
				me.resetFilterToDefault();
			}else if ((getArriveInput().val().length > 0 && getDepartInput().val().length > 0) && dateTimer != null){
				window.clearTimeout(dateTimer);
			}
		});

		departInput.keyup(function(evt){
			getDepartInput().parsley().validate();

			if(getArriveInput().val().length === 0 && getDepartInput().val().length === 0){
				me.resetFilterToDefault();
			}else if ((getArriveInput().val().length > 0 && getDepartInput().val().length > 0) && dateTimer != null){
				window.clearTimeout(dateTimer);
			}
		});

		arriveInput.focus(function(evt){
			if(getArriveInput().val().length === 0 && dateTimer != null){
				window.clearTimeout(dateTimer);
			}
		});

		departInput.focus(function(evt){
			if(getDepartInput().val().length === 0 && dateTimer != null){
				window.clearTimeout(dateTimer);
			}
		});

		arriveInput.blur(function(evt){
			getArriveInput().parsley().validate();

			if(getArriveInput().parsley().isValid() !== true && getArriveInput().val().length > 0){
				getArriveInput().focus();
			}
		});

		departInput.blur(function(evt){
			getArriveInput().parsley().validate();

			if(getDepartInput().parsley().isValid() !== true && getDepartInput().val().length > 0){
				getDepartInput().focus();
			}
		});

		arriveInput.change(function(evt){
			getArriveInput().parsley().validate();

			if(dateTimer != null) {
				window.clearTimeout(dateTimer);
			}

			var arrive = getArriveInput().val();
			var depart = getDepartInput().val();

			if(arrive.length > 0 && depart.length > 0){
				if(getArriveInput().parsley().isValid() && getDepartInput().parsley().isValid()){
					arrive = compass.util.parse.DateParse(arrive, _displayDateFormat);
					me.arrive = _format(arrive);
					depart = compass.util.parse.DateParse(depart, _displayDateFormat);
					me.depart = _format(depart);
					if(depart.valueOf() - arrive.valueOf() > 0){
						updateFilter(keys[0], 'arrive', me.arrive);
						updateFilter(keys[1], 'depart', me.depart);
						me.dispatchChange(100);
						window.setTimeout(function(){
							getDepartInput().focus();
						}, 100);
						sendGATracking();
						firstDateSearch = false;
					}else{
						me.alertDatesOrder();
					}
				}
			}else if((getArriveInput().val().length === 0 && getDepartInput().val().length > 0) || (getArriveInput().val().length > 0 && getDepartInput().val().length === 0)){
				if(dateTimer != null) {
					window.clearTimeout(dateTimer);
				}
				dateTimer = window.setTimeout(me.alertBothDates, 15000);
			}else if(arrive.length === 0 && depart.length === 0){
				me.resetFilterToDefault();

				window.setTimeout(function(){
					getDepartInput().focus();
				}, 100);
			}
		});

		departInput.change(function(evt){
			getDepartInput().parsley().validate();

			if(dateTimer != null) {
				window.clearTimeout(dateTimer);
			}

			var arrive = getArriveInput().val();
			var depart = getDepartInput().val();

			if(arrive.length > 0 && depart.length > 0){
				if(getArriveInput().parsley().isValid() && getDepartInput().parsley().isValid()){
					arrive = compass.util.parse.DateParse(arrive, _displayDateFormat);
					me.arrive = _format(arrive);
					depart = compass.util.parse.DateParse(depart, _displayDateFormat);
					me.depart = _format(depart);
					if(depart.valueOf() - arrive.valueOf() > 0){
						updateFilter(keys[0], 'arrive', me.arrive);
						updateFilter(keys[1], 'depart', me.depart);
						me.dispatchChange(100);
						sendGATracking();
						firstDateSearch = false;
					}else{
						me.alertDatesOrder();
					}
				}
			}else if((getArriveInput().val().length === 0 && getDepartInput().val().length > 0) || (getArriveInput().val().length > 0 && getDepartInput().val().length === 0)){
				if(dateTimer != null) {
					window.clearTimeout(dateTimer);
				}
				dateTimer = window.setTimeout(me.alertBothDates, 15000);
			}else if(arrive.length === 0 && depart.length === 0){
				me.resetFilterToDefault();
			}
		});

		var checkIn = d.div({className:'datePicker'},
			d.label({'for': arriveId},
			d.h3({className:'arriveLabel checkinLabel sectionTitle'},'Check-In'),
			arriveInput)
		);

		var checkOut = d.div({className:'datePicker'},
			d.label({'for': departId},
			d.h3({className:'departLabel checkinLabel sectionTitle'},'Check-Out'),
			departInput)
		);

		// make it look like the dates are blank, but their internal date picker values should be the default dates
		// NOT today's date
		if(_settings.defaultFilterDatesToBlank){
			arriveInput.val('');
			departInput.val('');
		}

		return d.div({className: 'checkinCheckOut'},
			checkIn,
			checkOut
		,d.div({className:'clear'}));
	};



	test.setDates = (function () {
		var keys = [generateFilterKey(), generateFilterKey()];

		return function (arrive, depart) {
			me.arrive = _format(compass.util.parse.DateParse(arrive, _displayDateFormat));
			me.depart = _format(compass.util.parse.DateParse(depart, _displayDateFormat));
			updateFilter(keys[0], 'arrive', me.arrive);
			updateFilter(keys[1], 'depart', me.depart);
			me.dispatchChange(100);
		};
	}());

	this.drawPriceSlider = function() {
		var key = generateFilterKey();
		var d = _d;
		return d.slider({
			label : 'Hotel Price Slider Filter',
			leftLabel : 'Low',
			rightLabel : 'High',
			className : 'price range ' + key,
			markers : [ 0.5 ],
			snapToMarkers : true,
			snapTolerance : 0.07,
			describeValue : function(val) {
				if(val < 0.20) { return 'Lowest price'; }
				else if(val < 0.45) { return 'Lower price'; }
				else if(val > 0.80) { return 'Highest price'; }
				else if(val > 0.55) { return 'Higher price'; }
				else { return 'All prices'; }
			}
		}).change(function(evt) {
			updateFilter(key, 'price', evt.percent);
			me.dispatchChange(150);
		});
	};

	this.drawAvailabilitySlider = function() {
		if(_settings.meetingInfo.groupsEnabled) {
			var maxHotel = _.max(_hotels, function (d) {
				return d.avail.status === 'NORMAL' ? d.avail.maxMultiBlockReservations : 0;
			});

			var key = generateFilterKey();
			var d = _d;
			var max = maxHotel.avail.status === 'NORMAL' ? maxHotel.avail.maxMultiBlockReservations : 1;
			_availSlider = d.slider({
				label : 'Hotel Availability Slider',
				leftLabel : '1',
				rightLabel : max,
				className : 'availability range ' + key,
				markers : [ ],
				range : [ 0, max ],
				units : 1,
				initial: 0,
				labelSlider: true,
				snapToMarkers : true,
				snapTolerance : 0.07,
				describeValue : function(val) {
					var value = Math.round(val);
					if(value <= 1) { return "Any rooms"; }
					else { return value + " rooms"; }
				}
			}).change(function(evt) {
				me.occupancy = evt.percent;
				updateFilter(key, 'availability', evt.percent);
				me.dispatchChange(150);

                if ( _settings.GINOn && Math.round(me.occupancy) >= _settings.GINThreshold && !_firedGINAlert ){
                    _firedGINAlert = true;
                    me.trigger('HotelFilterWidget.ginAlert', {});
                }

				// set the arrive/depart dates to the default dates but only if the meeting rule is set to Y
				// and they have not previously interacted with the arrive/depart dates inputs
				if(_settings.defaultFilterDatesToBlank && !getArriveInput().val().length && !getDepartInput().val().length ){
					var defaultDates = getDefaultDates();
					me.setArriveDepartDates(defaultDates.arrive, defaultDates.depart);

					// If the "require check in/out dates" meeting rule is set to Y, 
					// explicitly set these default dates into the active filter array
					// to satisfy the rule requirement and allow related widgets to update accodingly
					if (true === _requireCheckInOutDates) {
						var keys = [generateFilterKey(), generateFilterKey()];
						updateFilter(keys[0], 'arrive', defaultDates.arrive);
						updateFilter(keys[1], 'depart', defaultDates.depart);
						me.dispatchChange(100);
					}
				}
			});

			return [
				d.div({ className: 'sectionHeader' },
					d.h3({ className : 'sectionTitle'}, 'Number of Rooms')
				),
				_availSlider
			];
		}
	};

	this.drawSearch = function() {
		var key = generateFilterKey();
		var d = _d;
		return d.div({ className : 'search', role : 'search', 'ARIA-role' : 'search' },
			d.reader( d.h3('Search by hotel name') ),
			d.label(
				d.input({ className : key, type : 'text', autocomplete: 'off', 'ARIA-label' : 'Search: Hotel Name'
					}).keyup(function() {
					updateFilter(key, 'query', $j(this).val());
					me.dispatchChange(500);
				}).change(function(evt){me.bridgeCheck($j(evt.target).val());}),
				d.img({className : 'magnifyGlass', src: compass.staticPrefix + '/resources/img/compass/hotel/searchicon.png'})
			)
		);
	};

	this.drawDistanceSort = function() {
		var key = generateFilterKey();
		var d = _d;

		var dir = 1;
		var clickHandler = function(evt, state) {
			updateFilter(key, 'distance', state.active ? 1 : 0);
			me.dispatchChange();
			compass.GA.trackEvent('Filter', 'Distance Sort', state.active ? "ON" : "OFF");
		};
		var switchComponent = d.div({ className : 'distanceSort' },
			d.h3({className: 'sectionTitle'}, "Sort by Distance"),
			d.toggleSwitch({ label : 'Sort by distance', initialState : (!explicitSort && default_sort_distance) }).bind('toggleChange', clickHandler),
			d.div({ className : 'clear' })
		);

		if(default_sort_distance){
			updateFilter(key, 'distance', 1);
		}
		return switchComponent;
	};

	this.bridgeCheck = function(inputVal) {

		if(inputVal == 'shutupwesley') {
			me.trigger('shutupwesley');
		}
	};

	this.drawSearchOptions = function() {
		var d = _d;
		var _ids = {
			amenities: compass.generateId(),
			starRating: compass.generateId()
		};
		compass.generateId();

		var drawStarRatingTitle = function() {
			return d.div({ className : 'sectionHeader' },
				d.h3({className: 'sectionTitle', id: _ids.starRating}, 'Star Rating')
			);
		};

		return d.div({ className : 'accordion searchCriteria', role: 'form', 'ARIA-role': 'form'},
			d.div({ className : 'sectionHeader' },
				d.h3({className: 'sectionTitle', id: _ids.amenities}, 'Amenities')
			),
			d.fieldset({'ARIA-labelledby': _ids.amenities}, me.drawAmenities() ),
			_settings.displayHotelStars ? drawStarRatingTitle() : '',
			d.fieldset({'ARIA-labelledby': _ids.starRating}, _settings.displayHotelStars ? me.drawStarRating() : '' ),
			me.drawCategory()
		);
	};

	function updateSearchOption(key, type, value) {
		return function() {
			var check = $j(this);
			var val = check.val();
			//_widgetElem.append(_d.reader(_d.div({'aria-role': 'alert', 'role':'alert'},'SAY SOMETHING NICE')));
			if(check.is(':checked')) {
				updateFilter(key, value || val, true, type);
			} else {
				updateFilter(key, value || val, false, type);
			}
			me.dispatchChange();
		};
	}

	this.drawCategory = function() {
		if(_settings.category) {
			var d = _d;
			return d.div({ className : 'sectionHeader category' },
				'Category: ' + _settings.category
			);
		}
	};

	this.drawAmenities = function() {
		var types = [
			{name : 'Breakfast', code : 'Breakfast'},
			{name:  'Wireless Internet', code : 'Wireless Internet Access'},
			{name:  'Restaurant',  code : 'Restaurant'},
			{name:  'Pool',  code : 'Pool'},
			{name:  'Fitness Center',  code : 'Fitness Center'},
			{name:  'Business Center', code : 'Business Center'},
			{name:  'Spa', code : 'Spa'},
			{name:  'Shuttle Service', code : 'Shuttle Service' }
		];
		var d = _d;
		return d.ul({
			className : 'amenities'
		}, jQuery.map(types, function(elem, index) {
			var key = generateFilterKey();
			var labelId = compass.generateId();
			return d.li({ className : 'amenity' },
				d.label({
					'for': labelId
					},
					d.input({
						className : key,
						type : 'checkbox',
						value : elem.code,
						'ARIA-labelledby' : labelId,
						id: labelId
					}).change(updateSearchOption(key, 'amenity')),
					d.span({id: labelId}, elem.name)
				)
			);
		}));
	};

	this.drawStarRating = function() {
		var d = _d;
		var options = [];
		
		for ( var l = 0; l < 5; l++ ){
			var _elements = [];
			for ( var i = 0; i < 5; i ++){
				var is_solid = (i <= l);
				_elements.push(d.i({ className : (is_solid ? 'fa-solid' : 'fa-regular') +  ' fa-star' }));
			}
			options.push(d.span(_elements));
		}
			
		return d.ul({
			className : 'starRating'
		}, jQuery.map(options, function(elem, index) {
			var key = generateFilterKey();
			var labelId = compass.generateId();
			return d.li({ className : 'stars' },
				d.label({'for': labelId},
					d.input({ className : key, type : 'checkbox', value : elem, 'aria-label' : 'Hotels with ' + (index + 1) + ' Out of 5 Stars', id: labelId }).change(updateSearchOption(key, 'stars', index + 1)),
					elem
				)
			);
		}));
	};
	
	this.drawPriceSavingsExplanation = function() {
		var d = _d;

		var linkDOM = d.span({className: 'priceSavingsExplanationLinkWrapper'}, 
			d.span({className: 'priceSavingsIcon'}, d.i({className:'fa-solid fa-dollar-circle'})),
			d.span({className: 'priceSavingsExplanationLink'}, "How rate comparison is calculated")
		);

		linkDOM.activate(function() {
			compass.GA.trackEvent('Additional Information', 'Rate Comparison Description', 'Hotel Gallery');
			priceSavingsDialog = new compass.hotel.PriceSavingsExplanationWidget(null, {
				priceSavingsPercent: _settings.meetingInfo.priceSavingsPercent
			});
		});
		return linkDOM;
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'CRAP',
	widgetName : 'HotelFilterWidget',
	filterChangeDelay : 200,
	meetingInfo : {"minCheckIn" : "04/27/2012", "maxCheckIn" : "05/03/2012", "minCheckOut" : "04/28/2012",  "maxCheckOut" : "05/04/2012",  "starts": "04/29/2012", "ends": "05/01/2012" },
	displayHotelStars : 'true',
	dateFormat : 'MM/DD/YYYY',
	category : '',
	nightsArray : [],
	defaultFilterDatesToBlank : false,
	displayPriceSavings: false
} );

